import { useState, useEffect } from 'react';

const STORAGE_KEY = 'gallery-size-preference';
const DEFAULT_SIZE = 'medium';

// Size configurations: columns per breakpoint and min width per item
const SIZE_CONFIG = {
  'xs': {
    mobile: 2,
    tablet: 3,
    desktop: 5,
    minWidth: 180,
    label: 'Extra Small'
  },
  'small': {
    mobile: 2,
    tablet: 3,
    desktop: 4,
    minWidth: 220,
    label: 'Small'
  },
  'medium': {
    mobile: 1,
    tablet: 2,
    desktop: 3,
    minWidth: 280,
    label: 'Medium'
  },
  'large': {
    mobile: 1,
    tablet: 2,
    desktop: 2,
    minWidth: 380,
    label: 'Large'
  },
  'xl': {
    mobile: 1,
    tablet: 1,
    desktop: 1,
    minWidth: 480,
    label: 'Extra Large'
  }
};

const SIZES = ['xs', 'small', 'medium', 'large', 'xl'];
const MOBILE_SIZES = ['small', 'large']; // Simplified options for mobile

function useGallerySize() {
  const [size, setSize] = useState(() => {
    // Load from localStorage on initialization
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved && SIZES.includes(saved)) {
        return saved;
      }
    } catch (error) {
      // Gracefully fallback to default if localStorage fails
    }
    return DEFAULT_SIZE;
  });

  useEffect(() => {
    // Save to localStorage whenever size changes
    try {
      localStorage.setItem(STORAGE_KEY, size);
    } catch (error) {
      // Gracefully fallback if localStorage fails
    }
  }, [size]);

  const getGridClass = () => {
    // Tailwind requires full class names to be present in source code for JIT compilation
    // Cannot use template literals for class construction
    const classMap = {
      'xs': 'grid-cols-2 md:grid-cols-3 lg:grid-cols-5',
      'small': 'grid-cols-2 md:grid-cols-3 lg:grid-cols-4',
      'medium': 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
      'large': 'grid-cols-1 md:grid-cols-2 lg:grid-cols-2',
      'xl': 'grid-cols-1 md:grid-cols-1 lg:grid-cols-1'
    };
    return classMap[size] || classMap.medium;
  };

  return {
    size,
    setSize,
    sizeConfig: SIZE_CONFIG[size],
    sizes: SIZES,
    mobileSizes: MOBILE_SIZES,
    allSizeConfigs: SIZE_CONFIG,
    getGridClass
  };
}

export default useGallerySize;
